import { createStore, createLogger } from "vuex";
import * as actions from "./actions";
import * as getters from "./getters";
import mutations from "./mutations";
import { FeatureGroup } from "leaflet";

export default createStore({
  state() {
    return getDefaultState();
  },

  getters,
  actions,
  mutations,

  modules: {},
  //plugins: process.env.NODE_ENV !== "production" ? [createLogger()] : [],
});

export function getDefaultState() {
  return {
    // account
    token: "",
    accountDetails: null,

    // api network transfer status
    status: "success",

    // farm
    currentFarmId: "",
    currentFarmUnits: {},
    currentFarmMapLayer: new FeatureGroup({ bubblingMouseEvents: false }),

    farms: {},
    /*
    farms: {
      id : {
        name,
        endusers : {
          id : {
            name,
            timestamp,
            scheduleId,
            firmwareVersion,
            baseVersion,
            units : {
              ...
            }
          }
        },
        schedules : {
          id : {
            name,
            farm_id,
          }
        }
      }
    },
    */
  };
}
